var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmongUsHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29450",
    "data-name": "Group 29450",
    transform: "translate(-355 -582.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(355 582.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-among-us",
    transform: "translate(368 584.629)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8466",
    "data-name": "Rectangle 8466",
    width: 15.299,
    height: 15.299,
    transform: "translate(6 6.265)",
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50742",
    "data-name": "Path 50742",
    d: "M22.874,24.117H11.223A14.467,14.467,0,0,1,11,21.542v-4.72s.618-3.171,1.382-4.115a4.317,4.317,0,0,1,2.91-1.892,5.875,5.875,0,0,1,3.862.429c.923.609,1.446,2.862,1.635,4.845.639-.129,2.236.086,2.36.549C23.827,19.092,23.222,22.533,22.874,24.117Z",
    transform: "translate(-2.854 -2.554)",
    fill: "#e53935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50743",
    "data-name": "Path 50743",
    d: "M23.31,25.045H11.71c-.094-1.146-.206-3.025-.21-5.459.356,1.794.7,4.115,3,4.2,1.493.051,3.549.236,4.218-1.051a14.318,14.318,0,0,0,1.506-6.7,6.6,6.6,0,0,0-.914-3.733,8.043,8.043,0,0,1,1.721,5.021c.013.356.026.738.034,1.141,1.807-.064,2.545.644,2.6,1.008A14.125,14.125,0,0,1,23.31,25.045Z",
    transform: "translate(-3.14 -3.482)",
    fill: "#b71c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50744",
    "data-name": "Path 50744",
    d: "M20.728,17.367c0,1.575-.12,4.806-.18,6.364H19.69c.06-1.536.18-4.793.18-6.364,0-2.377-.627-5.429-1.523-6.016a5.512,5.512,0,0,0-3.532-.365,3.855,3.855,0,0,0-2.635,1.682l-.034.043a12.938,12.938,0,0,0-1.287,3.845V21.19a13.206,13.206,0,0,0,.232,2.54h-.875A14.574,14.574,0,0,1,10,21.19l.009-4.759c.064-.33.665-3.274,1.472-4.266l.034-.039a4.682,4.682,0,0,1,3.111-1.978,6.272,6.272,0,0,1,4.193.485C20.209,11.543,20.728,15.247,20.728,17.367Z",
    transform: "translate(-2.283 -2.167)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50745",
    "data-name": "Path 50745",
    d: "M12.547,17.28c2.239-.024,4.03.121,3.862,2.58s-3.638,2.374-4.03,2.29-3.358-.018-3.3-2.29S11.037,17.3,12.547,17.28Z",
    transform: "translate(-1.756 -6.324)",
    fill: "#01579b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50746",
    "data-name": "Path 50746",
    d: "M36.583,28.28a6.855,6.855,0,0,1-.524,1.983H35.017c.107-.082.485-.476.717-2.1a15.483,15.483,0,0,0-.4-5.484,4.811,4.811,0,0,0-1.875-.382l.043-.854a4.78,4.78,0,0,1,2.45.639C36.562,22.693,36.819,26.628,36.583,28.28Z",
    transform: "translate(-15.675 -8.699)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50747",
    "data-name": "Path 50747",
    d: "M10.154,18.55c.112.884-.084,1.438,1.091,1.522s3.466.439,4.035-.238.751-1.873-.382-2.26C14.094,17.3,11.358,16.855,10.154,18.55Z",
    transform: "translate(-2.371 -6.341)",
    fill: "#81d4fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50748",
    "data-name": "Path 50748",
    d: "M12.17,21.847a2.516,2.516,0,0,1-.451-.03c-.037-.008-.1-.015-.186-.026C9.239,21.5,8.077,20.6,8.077,19.107c0-1.158.5-3.106,3.856-3.141h.078c1.478-.016,2.752-.029,3.55.78a3.121,3.121,0,0,1,.707,2.373,2.321,2.321,0,0,1-.92,1.81A5.521,5.521,0,0,1,12.17,21.847Zm-.227-5.023c-3.007.032-3.007,1.726-3.007,2.283,0,1.334,1.544,1.685,2.706,1.832.117.015.206.027.258.038a4.942,4.942,0,0,0,2.942-.743A1.442,1.442,0,0,0,15.41,19.1a2.35,2.35,0,0,0-.46-1.749c-.542-.55-1.645-.539-2.929-.524Z",
    transform: "translate(-1.186 -5.572)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50749",
    "data-name": "Path 50749",
    d: "M13.508,18.92c.84-.14,2.2-.227,1.9.56-.21.56-3.083.938-3.083.28S13.508,18.92,13.508,18.92Z",
    transform: "translate(-3.612 -7.208)",
    fill: "#e1f5fe"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmongUsHighlighted);
export default __webpack_public_path__ + "static/media/amongUsHighlighted.01148ac2b08e456766d3370762bf0b4e.svg";
export { ForwardRef as ReactComponent };